import { render, staticRenderFns } from "./EnumField.vue?vue&type=template&id=1822dfb8&scoped=true"
import script from "./EnumField.vue?vue&type=script&lang=js"
export * from "./EnumField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1822dfb8",
  null
  
)

export default component.exports